import { ExternalLink } from 'lucide-react';
import React from 'react';
import { PageHeader } from '../../components/common/PageHeader';
import { ReputationMetrics } from '../metrics/tabs/ReputationMetrics';

export const ReputationPage: React.FC = () => {
  return (
    <section className="space-y-6">
      <PageHeader
        title="Reputation"
        description="Automated review requests and feedback linked to Google Business Profiles"
        right={
          <a
            href="https://docs.embedreach.com/reputation/introduction"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors">
            API Docs
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        }
      />
      <ReputationMetrics />
    </section>
  );
};
